module.exports = __webpack_public_path__ + "media/images/front/about/e-mediceo/cc_renewal_sp_003-a0cc5d3345c315896dce143aba9c206a.png";